import React, { Component } from 'react'
import GifPlayer from 'react-gif-player';


class FocusterGifSlide extends Component {
	constructor(props) {
    super(props)
    this.props = props;
    this.state = {
      playing: false
    }
  }
  onPlayButtonClick(id) {
	document.getElementById(id).click();
	this.setState({playing: !this.state.playing});
	var button;
	if(!this.state.playing) {
		button = document.getElementById('play-btn'+id);
		button.style.backgroundImage = 'url(./img/stop_gif.png)'
	
	} else {
		button = document.getElementById('play-btn'+id);
		button.style.backgroundImage = 'url(./img/play_gif.png)'
	}
  }
  render() {
  	if(!this.props.inverted) {
  		return (
	  		<div className={'slide__wrapper'}>
		  		<div className={"col-lg-7 col-md-7 col-xs-12  slide__img__wrapper--left"} >
					<GifPlayer id={this.props.id} className={'slide__img img-responsive'} gif={this.props.gif} still={this.props.still} />
		  		</div>
		        <div className={"col-lg-5 col-md-5 col-xs-12 slide__text slide__text--right"}>
		            <h2 className={"h--magenta"}>
		              {this.props.title}
		            </h2>
		            <br />
		            <p>
		              {this.props.content}
		            </p>
		            <div onClick={() => this.onPlayButtonClick(this.props.id)} > 
		            	<div id={'play-btn'+this.props.id} className={"play-gif-button"} ></div> <h3 className={"h--play-gif"}>Play demo</h3>
		        	</div>
		        </div>
	        </div>
		)
  	} else {
		return (
	  		<div className={'slide__wrapper'}>
		        <div className={"col-lg-5 col-md-5 col-xs-12 slide__text slide__text--left"}>
		            <h2 className={"h--magenta"}>
		              {this.props.title}
		            </h2>
		            <br />
		            <p>
		              {this.props.content}
		            </p>
		            <div onClick={() => this.onPlayButtonClick(this.props.id)}>
			            <div id={'play-btn'+this.props.id} className={"play-gif-button"}></div>
			            <h3 className={"h--play-gif"}>Play demo</h3>
		            </div>
		        </div>
		  		<div className={"col-lg-7 col-md-7 col-xm-12 slide__img__wrapper--right"} >
					<GifPlayer id={this.props.id} className={'slide__img img-responsive'} gif={this.props.gif} still={this.props.still} />
		  		</div>
	        </div>
		  )
		}
  	}
  	
}

export default FocusterGifSlide


// WEBPACK FOOTER //
// ./src/FocusterGifSlide.js